import {BaseCollection} from '../BaseCollection';
import {AppSettingModel} from '../../model/app-configs/AppSettingModel.js';

/**
 * @class AppSettingCollection
 * @extends BaseCollection
 */
export class AppSettingCollection extends BaseCollection {

    get model () {

        return AppSettingModel;
    }

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'app-configs';
        this.resource = 'settings';
    }
    set country (country) {

        country = country.toUpperCase();

        const modelsToRemove = this.filter((model) => {
            if (model.get('objectType') === AppSettingModel.OBJECT_TYPE.COUNTRY || 
            model.get('objectType') === AppSettingModel.OBJECT_TYPE.COUNTRY_CROP) {
                return !_.startsWith(model.get('objectId'), country);
            }
        });

        this.remove(modelsToRemove);
        this._country = country;
    }

    get country () {

        return this._country;
    }

    getCountryConfig (single, multiple) {

        const data = {};

        single = single || [
            'CREATE_CROP_SEASON_SELECTED_CROP',
            'CREATE_CROP_SEASON_SELECTED_TILLAGE',
            'CREATE_CROP_SEASON_SELECTED_PRE_CROP',
            'CREATE_CROP_SEASON_SELECTED_CROP_USAGE',
            'DEFAULT_WATER_RATE_IN_M3PM2',
            'MINIMUM_WATER_RATE_IN_M3PM2',
            'MAXIMUM_WATER_RATE_IN_M3PM2',
            'WATER_VOLUME_PER_AREA_UNIT',
            'WATER_VOLUME_UNIT',
            'PRODUCT_VOLUME_PER_AREA_UNIT',
            'PRODUCT_VOLUME_UNIT',
            'PRODUCT_WEIGHT_PER_AREA_UNIT',
            'PRODUCT_WEIGHT_UNIT',
        ];

        multiple = multiple || [
            'CREATE_CROP_SEASON_SUPPORTED_CROP',
            'CREATE_CROP_SEASON_SUPPORTED_TILLAGE',
            'CREATE_CROP_SEASON_SUPPORTED_PRE_CROP',
            'CREATE_TASK_SUPPORTED_WEED_RESISTANCE',
            'CREATE_CROP_SEASON_SUPPORTED_CROP_USAGE',
            'SUPPORTED_SOIL_TEXTURE',
            'SUPPORTED_SOIL_TAXONOMY'
        ];

        _.each(this.models, (s) => {
            const n = s.get('name');
            const v = s.get('value');

            _.each(single, (p) => {
                if(n === p){
                    data[p] = v;
                }
            });

            _.each(multiple, (p) => {
                if(n === p){

                    if(_.isUndefined(data[p])){
                        data[p] = [];
                    }

                    data[p].push(v);
                }
            });
        });

        return data;
    }

    getCountryCropConfig (cropUuid, single) {

        const data = {};

        _.each(this.models, (s) => {
            const n = s.get('name');
            const v = s.get('value');
            const m = s.get('objectId') === (this.country + '_' + cropUuid);

            single = single || [
                'CREATE_CROP_SEASON_MINIMUM_YIELD_EXPECTATION_IN_KGPM2',
                'CREATE_CROP_SEASON_AVERAGE_YIELD_EXPECTATION_IN_KGPM2',
                'CREATE_CROP_SEASON_MAXIMUM_YIELD_EXPECTATION_IN_KGPM2',
                'CREATE_CROP_SEASON_STEP_YIELD_EXPECTATION_IN_KGPM2',
                'CREATE_CROP_SEASON_YIELD_EXPECTATION_LOCAL_UNIT',
                'CREATE_CROP_SEASON_MINIMUM_SEEDING_DATE',
                'CREATE_CROP_SEASON_SELECTED_SEEDING_DATE',
                'CREATE_CROP_SEASON_MAXIMUM_SEEDING_DATE',
                'CROPSEASON_MAX_LENGTH_IN_DAYS',
                'CROPSEASON_ACTIVATION_LEAD_IN_DAYS',
                'IS_TIMING_CROP'
            ];

            _.each(single,(p, i) => {
                if(m && _.isUndefined(data[i]) && n === p){
                    data[single[i]] = v;
                }
            });
        });

        return data;
    }
}



// WEBPACK FOOTER //
// ./shared/collection/app-configs/AppSettingCollection.js